import { CommApiInstance } from "Utils/CommApiInstance";


const TcktRegApi = async (
) => {
    return await CommApiInstance.post(`memb/tckt/reg`,{
        apiBody: {
        }
    })
    .then((Resp) => Resp.data);
}

export default TcktRegApi;